$(function(){
    if($(".question-container").length){
        $('.question-container').click(function(){
            var isActive = $(this).hasClass('active');
            $('.question-container').removeClass('active');
            $('.answer-container').slideUp();
            if(!isActive){
                $(this).addClass('active');
                $(this).next().slideDown();
            }
        });
    }
    if($(".page--clever-kids").length){
        var id = location.hash;
        if(id){
            $('html, body').animate({
                scrollTop: $(id).offset().top - 150
            }, 1000);
            $(id).click();
        }
    }
});


